import { render, staticRenderFns } from "./envlist.vue?vue&type=template&id=1ffbf519&"
import script from "./envlist.vue?vue&type=script&lang=ts&"
export * from "./envlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports